exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-skeleton__contentSkeletonContainer__3tDv- {\n  margin-top: 8px;\n}\n.content-skeleton__cardSkeleton__2RsLA {\n  margin-bottom: 16px;\n}\n.content-skeleton__cardSkeleton__2RsLA svg {\n  display: block;\n  margin-bottom: 16px;\n}\n.content-skeleton__titleSkeleton__mnn30 {\n  margin: 0 0 8px 20px;\n}\n", ""]);

// exports
exports.locals = {
	"contentSkeletonContainer": "content-skeleton__contentSkeletonContainer__3tDv-",
	"cardSkeleton": "content-skeleton__cardSkeleton__2RsLA",
	"titleSkeleton": "content-skeleton__titleSkeleton__mnn30"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2122/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/content-skeleton.less
// module id = 1b07
// module chunks = 1